module.exports = __webpack_public_path__ + "static/amex-1b975cb8f5890e4c2fbdd092b4ea3ee4.svg";